import { Component, OnInit,Input, EventEmitter, Output } from '@angular/core';
import { KmsService } from 'src/app/areas/kms/kms.service';
import { SwMaskService } from 'src/app/librarys/components/basic-components/sw-mask/sw-mask.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';

@Component({
  selector: 'app-concept-copy',
  templateUrl: './concept-copy.component.html',
  styleUrls: ['./concept-copy.component.css']
})
export class ConceptCopyComponent implements OnInit {
  @Input() copyId:string;              // 概念主键id（自增长id）
  @Input() selectedVersion:any;              // 模型版本信息
  // 新增或编辑操作成功后向父组件发射数据
  @Output('conceptSave') conceptSave = new EventEmitter<any>();  
  // 取消操作成功后向父组件发射数据
  @Output('conceptCancel') conceptCancel = new EventEmitter<any>();  

  formModel:any = {}; // 表单信息
  ontologyTreeDatas:any = [];  // 概念树数据
  rootNode:any = {};  // 根节点信息
  readonlySelfIds:any = [];  // 不可选择的父级节点
  readonlySelfIds1:any = [];  // 不可选择的父级节点
  selectParentData: any;   // 父级分类下拉选中数据

  constructor(
    private kmsService: KmsService,
    private message: SwMassageBoxService,
    private swMaskService: SwMaskService
  ) { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.getOnlogyTreePageList();
    this.readonlySelfIds1 = [this.selectedVersion.id];
    // 根据主键查询概念信息
    this.kmsService.getConceptById(this.copyId).subscribe(
      result => {
          if (result.code == 200) {
              this.formModel = result.data;
              this.formModel.pid = result.data.parentId;
              if(result.data.parentId == 'root'){
                this.selectParentData = JSON.parse(JSON.stringify(this.rootNode));
                this.formModel.pid = this.rootNode.id;
              }
              this.formModel.sourceConceptId = result.data.conceptId;
              this.formModel.modelName = this.selectedVersion.modelName + this.selectedVersion.text;
          }
      }
    )
  }

  // 请求概念数据模型方法
  getOnlogyTreePageList() {
    this.ontologyTreeDatas = [];
    this.kmsService.getConceptTree(this.selectedVersion.id).subscribe(
        result => {
            if (result.code == 200) {
                if (!result.data) {
                    this.ontologyTreeDatas = [];
                    return;
                }
                let datas = result.data;
                this.ontologyTreeDatas = datas;
                this.rootNode = datas.length>0 ? datas[0] : {};
            } else {
                this.message.waring(result.msg);
            }
        }
    )
  }

  // 来源概念发生变化
  handleConceptChange1(event){
    
  }

  // 父级分类下拉点击方法
  handleConceptChange(event) {
    let items = this.ontologyTreeDatas.filter(item => item.id == event.id)[0];
    this.selectParentData = items;
  }

  // 表单提交方法
  onSubmit() {
    let parentId = '', parentCode = '';
    this.swMaskService.openMask("数据正在保存,请稍等...")
    if (this.selectParentData) {
        if (this.rootNode  && this.selectParentData.id === this.rootNode.id) {
            parentId = 'root';
            parentCode = '',
            this.formModel.conceptLevel = 1;
        } else {
            parentId = this.selectParentData.id;
            parentCode = this.selectParentData.code;
            this.formModel.conceptLevel = this.selectParentData.level + 1;
        }
    } else {
       parentId = this.formModel.pid;
       parentCode = this.formModel.parentCode;
    }
    let params = {
        conceptCode: this.formModel.conceptCode,
        conceptName: this.formModel.conceptName,
        conceptLevel: this.formModel.conceptLevel,
        parentId: parentId,
        sortNum: this.formModel.sortNum,
        modelVerId: this.selectedVersion.id,
        sourceConceptId: this.formModel.sourceConceptId,
        sourceModelVerId: this.selectedVersion.id,
    }
    this.kmsService.copyConcept(params).subscribe(
      result => {
          this.swMaskService.closeMask();
          if (result.code == 200) {
            this.message.success('操作成功！');
            this.conceptSave.emit(false);
          } else {
            this.message.waring(result.msg);
          }
      }
    )
  }

  // 取消新增或编辑操作
  cancel(){
    this.conceptCancel.emit(true);
  }
}

